import { Badge, Stack, Tooltip } from '@mui/material';
import DarkButton from './DarkButton';

export const QM_NEW_BADGE_SX = {
  '& .MuiBadge-badge': {
    fontSize: '0.58rem',
    fontWeight: 700,
    letterSpacing: 0.3,
    textTransform: 'uppercase',
    height: 16,
    minWidth: 16,
    px: 0.55,
    top: 3,
    right: -18,
    color: '#ffffff',
    backgroundColor: '#d97706',
    border: '1px solid rgba(255, 255, 255, 0.45)',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.35)'
  }
};

interface RaiseQMButtonProps {
  isOnline: boolean;
  isAnyPrinterDisabled: boolean;
  setOpenRaiseQM: (value: boolean) => void;
  label?: string;
  showNewBadge?: boolean;
  onClick?: () => void;
}

export default function RaiseQMButton({
  isOnline,
  isAnyPrinterDisabled,
  setOpenRaiseQM,
  label = 'Raise a QM',
  showNewBadge = false,
  onClick
}: RaiseQMButtonProps) {
  const labelNode = showNewBadge ? (
    <Badge
      badgeContent="new"
      color="default"
      overlap="rectangular"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={QM_NEW_BADGE_SX}>
      <span>{label}</span>
    </Badge>
  ) : (
    label
  );

  return (
    <Stack justifyContent="center">
      {isOnline ? (
        <Tooltip
          enterTouchDelay={0}
          title={
            isAnyPrinterDisabled
              ? 'A Printer in your settings is disabled, some functionality is restricted. Please select a new printer in Settings.'
              : ''
          }>
          <DarkButton
            variant="outlined"
            onClick={() => (onClick ? onClick() : setOpenRaiseQM(!isAnyPrinterDisabled))}
            sx={{ color: 'white' }}>
            {labelNode}
          </DarkButton>
        </Tooltip>
      ) : (
        <Tooltip enterTouchDelay={0} title="You are offline. This feature is not available when offline.">
          <DarkButton variant="outlined">{labelNode}</DarkButton>
        </Tooltip>
      )}
    </Stack>
  );
}
